<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I need help with my order</h1>
			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import Axios from 'axios';
	import BaseNavPage from './../components/BaseNavPage';
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "HelpWithMyOrderRental",

		components: {
			BaseNavLinks,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			return {
				loading: false,
				is_ia_item: true,
				condition: null,
				p_type: null
			}
		},

		computed: {
			is_exchange() {
				return this.p_type === 'marketplace';
			},

			links() {
				return [
					{
						to: '/where_is_my_book/' + parseInt(this.$route.params.id),
						caption: 'Where’s my book?'
					},
					{
						to: '/cancel/' + parseInt(this.$route.params.id),
						caption: 'I’d like to cancel this book'
					},
					{
						to: '/got_wrong_book/' + parseInt(this.$route.params.id),
						caption: 'I got the wrong book',
						enabled: !this.is_ia_item
					},
					{
						to: '/return/' + parseInt(this.$route.params.id),
						caption: 'I’d like to return my book'
					},
					{
						to: '/extend_rental/' + parseInt(this.$route.params.id),
						caption: 'I’d like to extend my rental term'
					},
					{
						to: '/rental_book_damaged/' + parseInt(this.$route.params.id),
						caption: 'My book was damaged when I got it'
					},
					{
						to: '/why_charged_tax/' + parseInt(this.$route.params.id),
						caption: 'Why did I get charged sales tax?'
					},
					{
						to: '/meant_other_payment_method/' + parseInt(this.$route.params.id),
						caption: this.$globs.institute_info.meant_other_payment_method
					}
				];
			}
		},

		mounted() {
			const self = this;

			self.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.is_ia_item = d['is_inclusive_access_item'];
					}
				})
				.finally(function () {
					self.loading = false;
				});

			self.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let d = response['data']['data'];
						self.condition = d['product_condition'];
						self.p_type = d['product_type'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		}
	}
</script>

<style scoped>

</style>